const paging = (() =>{

    const handlePaging = (el, callback) => {
        const paging = el.querySelector('[data-paging]');
        if (paging){
            const prevButton = paging.querySelector('[data-prev]');
            const nextButton = paging.querySelector('[data-next]');
            const pageDropdown = paging.querySelector('select');
            prevButton.addEventListener('click', () => {
                callback(el, prevButton.dataset.prev);
                window.scrollTo(0, 0);
            });
            nextButton.addEventListener('click', () => {
                callback(el, nextButton.dataset.next);
                window.scrollTo(0, 0);
            });
            pageDropdown.addEventListener('change', () => {
                callback(el, pageDropdown.value);
            });
        }
    }

    return {handlePaging};
})();
